import { axios } from '@/services/axios';

export const createTRSNode = (nodeData) => {
    const res = axios.post('/TRSNode', nodeData);
    return res;
};
